import * as React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {bindActionCreators} from 'redux';
import {isEmpty} from 'lodash';
import qs from 'querystringify';

import Loading from '../../shared/components/misc/FullScreenLoading';
import Alert from '../../shared/components/notices/Alert';
import ResetPasswordScreen from '../components/resetPassword/ResetPasswordScreen';
import ResetPasswordExpiredScreen from '../components/resetPassword/ResetPasswordExpiredScreen';
import {userResetPassword, validateUserResetPasswordToken} from '../actions';
import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {
  TrackEventName,
  PageViewName,
} from '../../shared/constants/SegmentEvents';
import {createPersonalTrustpass} from '../../trustpass/personalTrustpassActions';
import {loadUserFromToken} from '../actions';

export class ResetPasswordContainer extends React.Component {
  componentDidMount() {
    // TODO: Remove this once inactive modal issue
    // is fixed. https://firstcircle.atlassian.net/browse/ORIG-715
    // This will prevent user from accessing forgot password
    // when he/she is already loggedin
    this.props.auth_token && this.props.history.push('/');
    this.validateTokenFromUrl(); // check token first if it's valid
  }

  componentDidUpdate(prevProps) {
    // handle in api request success in component
    // to avoid passing callbacks in redux actions
    if (
      prevProps.isResettingPassword &&
      !this.props.isResettingPassword &&
      this.props.resetUserPasswordSuccess
    ) {
      this.onResetPasswordSuccess();
    }

    // Handle segment page view event
    if (
      prevProps.isValidatingResetPasswordToken &&
      !this.props.isValidatingResetPasswordToken
    ) {
      this.trackPageView();
    }
  }

  onRequestNewPassword = () => {
    segmentEventTracker.trackEvent(
      TrackEventName.REQUEST_NEW_RESET_LINK_CLICKED,
    );
    this.props.push('/forgot_password');
  };

  get tokenFromUrl() {
    return qs.parse(window.location.search).token;
  }

  get invalidToken() {
    return this.props.isResetPasswordTokenExpired || isEmpty(this.tokenFromUrl);
  }

  trackPageView() {
    const pageView = this.invalidToken
      ? PageViewName.PASSWORD_LINK_EXPIRED_VIEWED
      : PageViewName.RESET_PASSWORD_VIEWED;
    segmentEventTracker.trackPageView(pageView);
  }

  validateTokenFromUrl() {
    const token = this.tokenFromUrl;

    if (isEmpty(token)) return;
    const query = qs.stringify({reset_password_token: token});
    this.props.validateUserResetPasswordToken(query);
  }

  successNoticeAndRedirectToHome = () => {
    Alert('Success! Your password has been updated.');
    this.props.loadUserFromToken();
    this.props.push('/');
  }

  createPersonalTrustpassAndRedirectToHome() {
    this.props.createPersonalTrustpass(this.props.user.id, this.successNoticeAndRedirectToHome);
  }

  get isFromCSVUpload() {
    return isEmpty(this.props.user.active_personal_trustpass);
  }

  onResetPasswordSuccess = () => {
    return this.isFromCSVUpload
      ? this.createPersonalTrustpassAndRedirectToHome()
      : this.successNoticeAndRedirectToHome();
  }

  render() {
    const {
      isResettingPassword,
      isValidatingResetPasswordToken,
      userResetPassword,
    } = this.props;

    if (isValidatingResetPasswordToken) {
      return (
        <div className="ds-card">
          <Loading />
        </div>
      );
    }

    if (this.invalidToken) {
      return (
        <ResetPasswordExpiredScreen
          onRequestNewPassword={this.onRequestNewPassword}
        />
      );
    }

    return (
      <ResetPasswordScreen
        isResettingPassword={isResettingPassword}
        resetPasswordToken={this.tokenFromUrl}
        userResetPassword={userResetPassword}
      />
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push,
      userResetPassword,
      validateUserResetPasswordToken,
      createPersonalTrustpass,
      loadUserFromToken,
    },
    dispatch,
  );

const mapStateToProps = state => {
  return {
    user: state.user,
    auth_token: state.user.auth_token,
    resetUserPasswordSuccess: state.authentication.resetUserPasswordSuccess,
    isResettingPassword: state.authentication.isResettingPassword,
    isResetPasswordTokenExpired:
      state.authentication.isResetPasswordTokenExpired,
    isValidatingResetPasswordToken:
      state.authentication.isValidatingResetPasswordToken,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPasswordContainer);



// WEBPACK FOOTER //
// ./src/features/user/containers/ResetPasswordContainer.js